export default "__VITE_ASSET__BXeKq5Y2__"